import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const IC3SPoGApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "IC3SPoG" */ "./IC3SPoGApp");
    return { default: namedExport.IC3SPoGApp };
});

export const IC3SPoG: TeamAppConfig = {
    title: "IC3 & Teams SPoG",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "IC3SPoG",
    team: "IC3",
    publicId: "IC3IMPACTGRAPH\\IC3MetricsSPoG",
    owner: "ic3-business-metrics@microsoft.com",
    role: "*",
    tags: ["IC3", "Metrics", "Reliability"],
    app: IC3SPoGApp,
    path: "/IC3/home"
};
